const arrayRemoveIndex = require('./array-remove-index')

/*
 * either adds or removes 'value' to or from 'array' depending
 * on whethere or not 'value' is already present in 'array'
 * 
 * arrayToggle([ 1, 2, 3 ], 1) -> [ 2, 3 ]
 * 
 * arrayToggle([ 2, 3 ], 1) -> [ 2, 3, 1 ]
 */
module.exports = function arrayToggle (array, value) {
  const index = array.indexOf(value)

  if (index !== -1) {
    return arrayRemoveIndex(array, index)
  }

  return [ ...array, value ]
}
